export const pickListPt = {
  root: { class: 'pv-picklist' },
  pcListbox: {
    // TODO: Empty message is not configurable in PrimeVue 4.2.5, remove and use listbox props if new API is released
    emptyMessage: { style: 'display: none' },
    option: options => ({
      class: [
        'pv-picklist-option',
        {
          'pv-picklist-option-focus': options.context.focused,
          'pv-picklist-option-selected': options.context.selected
        }
      ]
    })
  },
  pcMoveToTargetButton: {
    root: { class: 'pv-picklist-btn pv-picklist-btn-to-target' }
  },
  pcMoveAllToTargetButton: {
    root: { class: 'pv-picklist-btn pv-picklist-btn-to-target-all' }
  },
  pcMoveToSourceButton: {
    root: { class: 'pv-picklist-btn pv-picklist-btn-to-source' }
  },
  pcMoveAllToSourceButton: {
    root: { class: 'pv-picklist-btn pv-picklist-btn-to-source-all' }
  },
  transferControls: {
    class: 'pv-picklist-transfer-btns'
  }
};